import { HttpErrorResponse } from "@angular/common/http";
import { Course } from "src/app/_models/Course";
import { LearnerCourse, LearnerCoursesList, UpdateLearnerCourseDto } from "src/app/_models/LearnerCourse";
import { LearnerCourseLog } from "src/app/_models/LearnerCourseLog";
import { MessageResultDto } from "src/app/_models/MessageResultDto";

export interface LearnerCourseState {
  result: LearnerCoursesList[];
  loader: boolean;
  error: HttpErrorResponse;
  updateDisable: boolean;
  updateDisableLoader: boolean;
  messageResult: MessageResultDto;
  langCode: string;

  reAssignResult: number;
  reAssignLoader: boolean;
  reAssignError: HttpErrorResponse;

  generateLearningPlanResult: number;
  generateLearningPlanLoader: boolean;
  generateLearningPlanError: HttpErrorResponse;

  learnerCourseLog: LearnerCourseLog;
  learnerCourseLogLoader: boolean;
  learnerCourseLogError: HttpErrorResponse;
  
  learnerCourse: LearnerCourse;
  learnerCourseLoader: boolean;
  learnerCourseError: any;

  updateLearnerCourseResult: UpdateLearnerCourseDto;
  updateLearnerCourseLoader: boolean;
  updateLearnerCourseError: any;

  learnerCourseLogStatus: LearnerCourseLog;
  learnerCourseLogStatusLoader: boolean;
  learnerCourseLogStatusError: HttpErrorResponse;

  addLearnerCourseListResult: boolean;
  addLearnerCourseListLoader: boolean;
  addLearnerCourseListError: HttpErrorResponse;

  learnerCourseScreenerResult: Course[];
  learnerCourseScreenerLoader: boolean;
  learnerCourseScreenerError: HttpErrorResponse;
}

export const initialLearnerCourseState: LearnerCourseState = {
  result: null,
  loader: false,
  error: null,
  updateDisable: false,
  updateDisableLoader: false,
  messageResult: null,
  langCode: null,
  
  reAssignError: null,
  reAssignLoader: false,
  reAssignResult: null,

  generateLearningPlanResult: null,
  generateLearningPlanLoader: false,
  generateLearningPlanError: null,

  learnerCourseLog: null,
  learnerCourseLogLoader: false,
  learnerCourseLogError: null,

  learnerCourse: null,
  learnerCourseLoader: false,
  learnerCourseError: null,

  updateLearnerCourseResult: null,
  updateLearnerCourseLoader: false,
  updateLearnerCourseError: null,

  learnerCourseLogStatus: null,
  learnerCourseLogStatusLoader: false,
  learnerCourseLogStatusError: null,

  addLearnerCourseListResult: null,
  addLearnerCourseListLoader: false,
  addLearnerCourseListError: null,

  learnerCourseScreenerResult: [],
  learnerCourseScreenerLoader: false,
  learnerCourseScreenerError: null
};
